import React from 'react';
import classNames from 'classnames';

import styles from './Card.module.scss';

export default function Card({ children, className, isFixed = false }) {
  return (
    <div
      className={classNames(
        styles.Card,
        isFixed ? styles.Fixed : styles.Stretch,
        className
      )}
    >
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ children, className }) {
  return <div className={classNames(styles.Header, className)}>{children}</div>;
};

Card.Body = function CardBody({ children, className, scrollable = true }) {
  return (
    <div
      className={classNames(
        styles.Body,
        scrollable && styles.Scrollable,
        className
      )}
    >
      {children}
    </div>
  );
};
